module.exports = __webpack_public_path__ + "img/lb_04.435b90b0.png";